import { Container, Loader, Text } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { BlurredGraphBackground } from "../components/BlurredGraphBackground";
import { RelatanceLockup } from "../components/Brand/RelatanceLockup";
import { BetaAccessStatus } from "../graphql/generated/types.gen";
import { useAuthCompat } from "../hooks/useAuthCompat";

export const Route = createFileRoute("/waitlist")({
	component: WaitlistPage,
});

function WaitlistPage() {
	const { user, isLoading, signOut } = useAuthCompat();

	useEffect(() => {
		if (isLoading) return;
		if (!user) {
			window.location.href = "/welcome";
			return;
		}
		if (user.betaAccessStatus === BetaAccessStatus.Approved) {
			window.location.href = "/";
		}
	}, [user, isLoading]);

	if (isLoading || !user) {
		return (
			<div className="flex items-center justify-center min-h-screen">
				<Loader size="lg" color="gold" />
			</div>
		);
	}

	return (
		<BlurredGraphBackground>
			<Container size="sm">
				<div className="plate flex flex-col items-center text-center gap-6">
					<RelatanceLockup />

					<span className="kicker">Waitlist</span>

					<Text
						size="xl"
						style={{
							color: "var(--ink)",
							fontFamily: "var(--font-display)",
							fontWeight: 700,
							letterSpacing: "-0.03em",
							lineHeight: 1.06,
						}}
					>
						You are on the waitlist
					</Text>

					<Text
						size="md"
						maw={460}
						style={{ color: "var(--ink-secondary)", lineHeight: 1.62 }}
					>
						Thanks for signing up for Relatance. We are in a closed beta and
						will let you know when it is your turn to join.
					</Text>

					{user?.email && (
						<div
							className="px-6 py-4 w-full max-w-[400px]"
							style={{
								background: "var(--card)",
								border: "1px solid var(--hairline-soft)",
							}}
						>
							<Text size="sm" mb={4} style={{ color: "var(--ink-secondary)" }}>
								Signed up as
							</Text>
							<Text size="lg" fw={500} style={{ color: "var(--ink)" }}>
								{user.email}
							</Text>
						</div>
					)}

					<button
						type="button"
						onClick={() => signOut()}
						className="bg-transparent cursor-pointer px-4 py-2 font-semibold"
						style={{
							color: "var(--ink)",
							border: "1px solid var(--hairline-strong)",
							fontFamily: "var(--font-body)",
						}}
					>
						Sign out
					</button>
				</div>
			</Container>
		</BlurredGraphBackground>
	);
}
